<template>
  <section class="all-cases-view" id="uaqcResults">
    <div class="container-xxs">
      <div class="listings-navbar">
        <el-row gutter="20">
          <el-col :lg="12" :xl="12">
            <ul class="d-flex list-items-group-15 barcode-print">
              <li v-if="selectedCaseIds.length">
                <!-- v-if="selectedCaseIds.length"  in li -->
                <el-button
                  class="btn button-with-icon"
                  auto-insert-space
                  @click="onPrintBarCodes"
                >
                  <span class="mr-8">
                    <img
                      src="@/assets/images/printer-icon-white.svg"
                      alt="icon"
                      class="active"
                    />
                    <img
                      class="inactive"
                      src="@/assets/images/printer-icon-black.svg"
                      alt="icon"
                    />
                  </span>
                  <span>PRINT BARCODE</span>
                </el-button>
              </li>

              <li v-if="false">
                <div class="form-element input-with-icon search-input-lg">
                  <el-input
                    placeholder="Accession / Patient Name"
                    v-model="search_string"
                    @input="getAutoCompleteCases()"
                    :clearable="true"
                  ></el-input>
                  <span>
                    <img
                      src="@/assets/images/icons/search-icon-with-bg-red.svg"
                      alt="icon"
                      class="img-fluid icon"
                    />
                  </span>
                </div>
              </li>
            </ul>
          </el-col>
          <el-col :lg="12" :xl="12" v-if="false">
            <ul class="d-flex justify-content-end list-items-group-15 w-90">
              <li v>
                <el-button class="btn button-with-icon">
                  <span class="mr-8">
                    <img
                      src="@/assets/images/icons/plus-icon.svg"
                      alt="icon"
                      class="inactive"
                    />
                    <img
                      src="@/assets/images/icons/plus-icon-white.svg"
                      alt="icon"
                      class="active"
                    />
                  </span>
                  <span>Add</span>
                </el-button>
              </li>
            </ul>
          </el-col>
        </el-row>
      </div>
      <div class="primary-content-view-new">
        <div
          class="listings listings__table listings__all-cases"
          id="all-cases-listings"
        >
          <el-table
            :data="tableData"
            style="width: 100%"
            @sort-change="onChangeSort"
            @selection-change="handleSelectionChange($event)"
          >
            <el-table-column
              type="selection"
              width="40"
              class="selection-check"
            ></el-table-column>
            <el-table-column prop="qcLevel" label="QC Level" width="400px">
              <template #default="scope">
                <span class="accesion"> {{ scope.row.qcLevel }}</span>
              </template>
            </el-table-column>
            <el-table-column label="QC NAME" width="220px">
              <template #default="scope">
                <span>{{ scope.row.firstName }} {{ scope.row.lastName }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <div class="container-default">
      <div class="listings-navbar">
        <el-row gutter="20">
          <el-col :lg="24" :xl="24">
            <ul class="d-flex justify-content-between list-items-group-15 w-90">
              <li>
                <h2 class="qc_header">Urinalysis QC Results</h2>
              </li>
              <li class="date">
                <el-form>
                  <el-form-item class="date mb-10">
                    <el-date-picker
                      style="width: 70% !important"
                      v-model="value1"
                      type="daterange"
                      range-separator="To"
                      start-placeholder="Start date"
                      end-placeholder="End date"
                      format="MM-DD-YYYY"
                      :disabled-date="disabledDate"
                      value-format="YYYY-MM-DD"
                      @change="fetchUaQcResults"
                    >
                    </el-date-picker>
                  </el-form-item>
                </el-form>
              </li>
            </ul>
          </el-col>
        </el-row>
      </div>

      <div class="primary-content-view-new" v-loading="loading">
        <div
          class="listings listings__table listings__all-cases"
          id="all-cases-listings"
          v-if="
            this.getUrinalysisQcResults &&
            urinalysisResults &&
            urinalysisResults.length != 0
          "
        >
          <el-table :data="urinalysisResults" style="width: 100%">
            <el-table-column
              prop="accession_id"
              label="ACCESSION ID"
              min-width="65px"
            >
              <template #default="scope">
                <span class="accesion">{{ scope.row.accession_id }}</span>
              </template>
            </el-table-column>
            <el-table-column label="DATE" min-width="65px">
              <template #default="scope">
                {{ formatDate(scope.row.time) }}
              </template>
            </el-table-column>
            <el-table-column label="LEUKOCYTES(Leu/μL)" min-width="100px">
              <template #default="scope">
                {{ getResultValue(scope.row.results, "LEUKOCYTES") }}
              </template>
            </el-table-column>
            <el-table-column label="GLUCOSE" min-width="50px">
              <template #default="scope">
                {{ getResultValue(scope.row.results, "GLUCOSE") }}
              </template>
            </el-table-column>
            <el-table-column label="pH" min-width="40px">
              <template #default="scope">
                {{ getResultValue(scope.row.results, "pH") }}
              </template>
            </el-table-column>
            <el-table-column label="NITRITE(mg/dL)" min-width="80px">
              <template #default="scope">
                {{ getResultValue(scope.row.results, "NITRITE") }}
              </template>
            </el-table-column>
            <el-table-column label="PROTEIN(g/L)" min-width="80px">
              <template #default="scope">
                {{ getResultValue(scope.row.results, "PROTEIN") }}
              </template>
            </el-table-column>
            <el-table-column label="SPECIFIC GRAVITY" min-width="90px">
              <template #default="scope">
                {{ getResultValue(scope.row.results, "SPECIFIC GRAVITY") }}
              </template>
            </el-table-column>
            <el-table-column
              label="KETONE (ACETOACETIC ACID)"
              min-width="140px"
            >
              <template #default="scope">
                {{
                  getResultValue(scope.row.results, "KETONE (ACETOACETIC ACID)")
                }}
              </template>
            </el-table-column>
            <el-table-column label="BILIRUBIN(μmol/L)" min-width="100px">
              <template #default="scope">
                {{ getResultValue(scope.row.results, "BILIRUBIN") }}
              </template>
            </el-table-column>
            <el-table-column label="UROBILINOGEN(μmol/L)" min-width="120px">
              <template #default="scope">
                {{ getResultValue(scope.row.results, "UROBILINOGEN") }}
              </template>
            </el-table-column>
            <el-table-column label="BLOOD(Ery/μ)">
              <template #default="scope">
                {{ getResultValue(scope.row.results, "BLOOD") }}
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-else>
          <p class="no_data">No Data</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "QcTable",

  data() {
    return {
      tableData: [
        {
          qcLevel: "LEVEL1",
          id: 1,
          firstName: "NEGATIVE",
          lastName: "CONTROL",
        },
        {
          qcLevel: "LEVEL2",
          id: 2,
          firstName: "POSITIVE",
          lastName: "CONTROL",
        },
      ],
      selectedCaseIds: [],
      loading: false,
      value1: "",
      disabledDate: (time) => {
        return time.getTime() > Date.now();
      },
      urinalysisResults: [],
    };
  },
  computed: {
    ...mapGetters("qcCharts", ["getUrinalysisQcResults"]),
  },
  methods: {
    formatDate(dateString) {
      const date = new Date(dateString);
      const month = ("0" + (date.getMonth() + 1)).slice(-2);
      const day = ("0" + date.getDate()).slice(-2);
      const year = date.getFullYear();
      return `${month}-${day}-${year}`;
    },
    getResultValue(results, testName) {
      const result = results.find((result) => result.test === testName);
      return result ? result.value : "-";
    },
    async fetchUaQcResults() {
      try {
        this.loading = true;
        let params = {};
        if (this.value1 && this.value1.length == 2) {
          params.from_date = this.value1[0];
          params.to_date = this.value1[1];
        }
        await this.$store.dispatch("qcCharts/fetchUrinalysisQcResults", params);
        if (this.getUrinalysisQcResults && this.getUrinalysisQcResults.length) {
          this.urinalysisResults = [...this.getUrinalysisQcResults];
        } else {
          this.urinalysisResults = [];
        }
        this.loading = false;
      } catch (err) {
        this.loading = false;
        console.log(err);
      }
    },
    handleSelectionChange(rows) {
      if (rows) {
        this.selectedCaseIds = [];
        for (let caseData of rows) {
          this.selectedCaseIds.push(caseData.id);
        }
      } else {
        this.selectedCaseIds = [];
      }
    },
    onPrintBarCodes() {
      let urlData = this.$router.resolve({
        name: "QcBrcode",
        path: "ua-qc-barcodes",
        query: {
          ids: this.selectedCaseIds,
        },
      });
      window.open(urlData.href, "_blank");
    },
    onPrintUrinalysisResults() {
      const routeData = this.$router.resolve({
        name: "PrintUrinalysisResults",
        path: "print-urinalysis-results",
        query: { from_date: this.value1[0], to_date: this.value1[1] },
      });
      window.open(routeData.href, "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
.all-cases-view {
  // margin-top: 15vh;
  .tabel-card {
    background: #fff;
    border-radius: 10px;
    padding: 20px;
    .heading-block {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 1rem;
      .heading {
        color: #273480;
        font-weight: 600;
      }
    }
  }
}
.qc_header {
  color: #1b2459;
  font-weight: 600;
  font-size: 16px;
  text-align: center;
  white-space: nowrap;
  text-transform: uppercase;
  letter-spacing: 0;
}
.no_data {
  text-align: center;
  padding-top: 3rem;
  color: #eb5757;
}
</style>
<style lang="scss">
#uaqcResults {
  .listings__table .el-table table thead tr th .cell {
    text-transform: none !important;
  }
}
</style>
